import cls from 'classnames';
import { FileItem as FileItemType } from '../../api/agentService';
import styles from './styles.module.scss';

// 图标导入
import codeIcon from '../../assets/icons/code.svg';
import excelIcon from '../../assets/icons/excel.svg';
import pdfIcon from '../../assets/icons/pdf.svg';
import pptIcon from '../../assets/icons/ppt.svg';
import textIcon from '../../assets/icons/text.svg';
import wordIcon from '../../assets/icons/word.svg';

export interface FileItemProps {
  /** 文件信息 */
  fileItem: FileItemType;
  /** 自定义类名 */
  className?: string;
  /** 尺寸 */
  size?: 'small' | 'medium' | 'large';
}

// 根据 MIME 类型获取对应图标和类型名称
const getFileIcon = (mimeType?: string): { icon: string; typeName: string } => {
    if (!mimeType) return { icon: textIcon, typeName: 'Plain Text' };
    
    if (mimeType.includes('pdf')) return { icon: pdfIcon, typeName: 'PDF' };
    if (mimeType.includes('word') || mimeType.includes('msword') || mimeType.includes('wordprocessingml')) {
        return { icon: wordIcon, typeName: 'Document' };
    }
    if (mimeType.includes('excel') || mimeType.includes('spreadsheet') || mimeType.includes('ms-excel')) {
        return { icon: excelIcon, typeName: 'Spreadsheet' };
    }
    if (mimeType.includes('powerpoint') || mimeType.includes('presentation') || mimeType.includes('ms-powerpoint')) {
        return { icon: pptIcon, typeName: 'Presentation' };
    }
    if (mimeType.includes('javascript') || mimeType.includes('typescript') || mimeType.includes('json') 
        || mimeType.includes('html') || mimeType.includes('css') || mimeType.includes('xml')
        || mimeType.includes('python') || mimeType.includes('java') || mimeType.includes('cpp')
        || mimeType.includes('c++') || mimeType.includes('php') || mimeType.includes('ruby')
        || mimeType.includes('go') || mimeType.includes('rust') || mimeType.includes('swift')) {
        return { icon: codeIcon, typeName: 'Code' };
    }
    
    return { icon: textIcon, typeName: 'Plain Text' };
};

const FileItem = ({
    fileItem,
    className,
    size = 'medium'
}: FileItemProps) => {
    // 获取文件图标和类型信息
    const fileIconInfo = getFileIcon(fileItem.file_type);
  
    // 获取文件名
    const getFileName = () => {
        if(fileItem.name){
            return fileItem.name;
        }
        // 从 URL 中提取文件名
        const urlParts = fileItem.url.split('/');
        return urlParts[urlParts.length - 1] || 'Unknown file';
    };

    // 获取文件大小
    const getFileSize = () => {
        return null;
    };



    return (
        <div 
            className={cls(
                styles.fileItem,
                styles[size],
                className
            )}
        >
            {/* 文件内容区域 */}
            <div className={styles.fileContent}>
                <div className={styles.fileIcon}>
                    <div className={styles.iconContainer}>
                        <img src={fileIconInfo.icon} alt={fileIconInfo.typeName} className={styles.icon} />
                    </div>
                    <div className={styles.fileInfo}>
                        <div className={styles.fileName} title={getFileName()}>
                            {getFileName()}
                        </div>
                        <div className={styles.fileType}>
                            {fileIconInfo.typeName}
                        </div>
                        {getFileSize() && (
                        <div className={styles.fileSize}>
                            {getFileSize()}
                        </div>
                        )}
                    </div>
                </div>
            </div>


        </div>
    );
};

export default FileItem;
